
/*
Like angular orderBy filter, but allows reversing each parameter individually (even getters)
 */
angular.module('smart-table').filter('multiOrderBy', function() {
  return require('orderby');
});

//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL2hvbWUvZG9vemVyL3Byb2plY3RzL3N0LW11bHRpLXNvcnQvc3JjL211bHRpX29yZGVyX2J5LmNvZmZlZSIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi9ob21lL2Rvb3plci9wcm9qZWN0cy9zdC1tdWx0aS1zb3J0L3NyYy9tdWx0aV9vcmRlcl9ieS5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBOzs7QUFHQSxPQUFPLENBQUMsTUFBUixDQUFlLGFBQWYsQ0FBNkIsQ0FBQyxNQUE5QixDQUFxQyxjQUFyQyxFQUFxRCxTQUFBO1NBQ25ELE9BQUEsQ0FBUSxTQUFSO0FBRG1ELENBQXJEIn0=
